import { render, staticRenderFns } from "./TextLanguagesDialog.vue?vue&type=template&id=0b604c08&scoped=true&lang=pug&"
import script from "./TextLanguagesDialog.vue?vue&type=script&lang=ts&"
export * from "./TextLanguagesDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b604c08",
  null
  
)

export default component.exports